import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/transferAdditionalOptions', request)
}

export {get}
